(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const links = document.querySelectorAll('a[href^="#teampop-"]');
        const popup = document.querySelector("#team-popup");
        if (!popup) return;
        const popImg = popup.querySelector(".popup-content-img");
        const popupTitle = popup.querySelector(".popup-content-title");
        const popupExtra = popup.querySelector(".popup-content-desc");
        const popupClose = popup.querySelector(".popup-close");
        const popupOverlay = popup.querySelector(".popup-overlay");
        const popupPrev = popup.querySelector(".popup-prev");
        const popupNext = popup.querySelector(".popup-next");
        const htmlEl = document.documentElement;

        const teamDescriptions = {
            "teampop-1": `<p> Andrew Loveland brings relentless passion and precision to Planet Bean’s leadership, overseeing everything from green coffee sourcing to the final roast. As both President and Director of Coffee, he manages daily roastery operations, negotiates direct trade contracts, and ensures every batch meets Planet Bean’s exacting standards. </p>`,

            "teampop-2": `<p> For over 15 years, Roberta has been the heartbeat of Planet Bean’s daily operations, blending sharp HR leadership with a rare talent for fostering workplace joy. Her dedication to employee wellbeing and operational excellence has made Planet Bean not just a workplace, but a community where staff thrive. Roberta is the reason Planet Bean feels like family. </p> <p> "Happy teams brew exceptional coffee." </p>`,

            "teampop-3": `<p> Jon ensures every batch of Planet Bean coffee meets our exacting standards, overseeing inventory, quality control, and production with precision. A true coffee specialist, his expertise guarantees that from roasting to packaging, your cup is always fresh, flavorful, and ethically crafted.</p> <p> Jon maintains flavor profiles across every batch and keeps our supply chain seamless and sustainable. </p> <p> "Great coffee isn’t an accident—it’s a system." </p>`,

            "teampop-4": `<p> Gavin brings mechanical precision and creative energy to Planet Bean’s roastery. By day, he crafts flawless roasts and keeps our equipment humming; by night, he books Guelph’s best live music as a promoter. A former motorcycle customization pro, he now applies his technical skills to coffee logistics and event planning. </p>`,

            "teampop-5": `<p> Tye is a true coffee artist, renowned across Guelph for crafting precision espresso drinks with both skill and heart. At our Grange location, he’s the maestro behind the machine—whether pulling the perfect shot, free-pouring latte art, or customizing drinks for regulars (he remembers everyone’s favorite order). - Espresso Scientist - Adjusts grind, dose, and extraction by the second </p> <p> "Coffee should surprise and delight—every single time." </p>`,

            "teampop-6": `<p> Born and raised on a family coffee farm in Ethiopia, Titi Tekle grew up with the aroma of freshly roasted beans and the rhythm of daily coffee ceremonies. For Titi, coffee is more than a drink—it’s a ritual of togetherness, storytelling, and love, passed down through generations. </p> <p> Titi’s mission is simple: "Share the magic that turns beans into belonging." </p>`,
        };

        const teamIds = Object.keys(teamDescriptions);
        let currentPopupId = "";

        function showPopup(popupId) {
            const link = document.querySelector(`a[href="#${popupId}"]`);
            if (!link) return;

            const parent = link.closest(".column__inner"); 
            const imgHTML = parent.querySelector(".column__image").outerHTML;
            const headingHTML = parent.querySelector(".column__heading").outerHTML;
            const textHTML = parent.querySelector(".column__text").outerHTML;

            popImg.innerHTML = imgHTML || "";
            popupTitle.innerHTML = (headingHTML || "") + (textHTML || "");
            popupExtra.innerHTML = teamDescriptions[popupId] || "";

            currentPopupId = popupId;
            popup.style.display = "block";
            htmlEl.classList.add("teamPopup-open");
        }

        links.forEach((link) => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const popupId = this.getAttribute("href").substring(1);
                showPopup(popupId);
            });
        }); 

        const closePopup = () => {
            popup.style.display = "none";
            htmlEl.classList.remove("teamPopup-open");
        };

        popupClose.addEventListener("click", closePopup);
        popupOverlay.addEventListener("click", closePopup); 

         if (popupNext && popupPrev) {
            popupNext.addEventListener("click", function () {
                const currentIndex = teamIds.indexOf(currentPopupId);
                const nextIndex = (currentIndex + 1) % teamIds.length;
                showPopup(teamIds[nextIndex]);
            });

            popupPrev.addEventListener("click", function () {
                const currentIndex = teamIds.indexOf(currentPopupId);
                const prevIndex = (currentIndex - 1 + teamIds.length) % teamIds.length;
                showPopup(teamIds[prevIndex]);
            });
        }

    });

    document.addEventListener("DOMContentLoaded", function () {
        const menuLinks = document.querySelectorAll(".pb-menuList span");
        const tabs = document.querySelectorAll(".pb-menu-tab");

        menuLinks.forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();

                const targetId = this.getAttribute("data-target"); 
                menuLinks.forEach(item => item.classList.remove("pb-menu-active")); 
                this.classList.add("pb-menu-active"); 
                tabs.forEach(tab => tab.classList.remove("pb-menu-tab-active")); 
                document.getElementById(targetId).classList.add("pb-menu-tab-active");
            });
        });
    });

})();
